import { getName } from "country-list";
import { format } from "date-fns";

const convertToCSV = (array) => {
  const headers = Object.keys(array[0]);
  const csvRows = [];
  // Add the headers row
  csvRows.push(headers.join(","));

  // Add the data rows
  for (const row of array) {
    const values = headers.map((header) => {
      const escaped = ("" + row[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
};

export function formatDate(dateString) {
  if (dateString) {
    return format(dateString, "MMMM do, yyyy");
  } else {
    ("-");
  }
}

export const downloadCSV = (data, filename = "data.csv") => {
  let array;

  if (filename == "appointment_history.csv") {
    array = data.map((row) => {
      return {
        position: row.position || "",
        appointed: formatDate(row?.start_date ? row?.start_date : ""),
        end_date: formatDate(row?.end_date ? row?.start_date : ""),
        status: row.status || "",
      };
    });
  } else if (filename == "global_entities.csv") {
    array = data.map((entity) => {
      return {
        "Registered Name": entity.name,
        Type: entity.type,
        Country: getName(entity.country),
        "Parent Entity": entity?.parentEntity?.name || "",
        "Account Manager": entity?.account_manager_name || "",
      };
    });
  } else {
    array = data.map((entity) => {
      return {
        name: entity.name,
        country: getName(entity.country),
        type: entity.type,
        region: entity.region,
        status: entity.status,
        account_manager: entity.accountManager?.name,
        point_contact: entity.pointContact?.name,
        parent: entity.name,
      };
    });
  }
  const csv = convertToCSV(array);
  const blob = new Blob([csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
